// Whether `expert` — a hit from the experts index, or the `expert` sub-object embedded in a
// story-idea/public-pitch hit — is the signed-in viewer's own self-represented expert profile.
// `expert.id`/`promo_entity_id` lives in a different table (and id space) than the viewer's
// profile, so it can never be compared against CURRENT_PROFILE_ID directly. What IS shared is the
// slug: a self-represented expert's slug is kept in lockstep with its representing profile's slug
// (see Id::PromoEntity::Expert#create_self_expert_with_profile!/#update_self_expert_with_profile!),
// and every signed-in user's slug matches their own profile's slug (the "User slug and profile
// slug must match" invariant in the globalThis bridge). So CURRENT_SLUG is the identity signal
// that already reaches these cards. No action aimed at the expert (message, call for sources)
// should ever target the viewer themselves.
export default function isOwnExpert(expert) {
  const currentSlug = globalThis.Qwoted?.CURRENT_SLUG;
  return !!expert?.slug && !!currentSlug && expert.slug === currentSlug;
}
